import createIcon from '../../createIcon';

/**
 * @component @name Explore
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMTAuOUMxMS4zOSAxMC45IDEwLjkgMTEuMzkgMTAuOSAxMkMxMC45IDEyLjYxIDExLjM5IDEzLjEgMTIgMTMuMUMxMi42MSAxMy4xIDEzLjEgMTIuNjEgMTMuMSAxMkMxMy4xIDExLjM5IDEyLjYxIDEwLjkgMTIgMTAuOVpNMTIgMkM2LjQ4IDIgMiA2LjQ4IDIgMTJDMiAxNy41MiA2LjQ4IDIyIDEyIDIyQzE3LjUyIDIyIDIyIDE3LjUyIDIyIDEyQzIyIDYuNDggMTcuNTIgMiAxMiAyWk0xNC4xOSAxNC4xOUw2IDE4TDkuODEgOS44MUwxOCA2TDE0LjE5IDE0LjE5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Explore = createIcon('Explore', [
  [
    'path',
    {
      d: 'M12 10.9C11.39 10.9 10.9 11.39 10.9 12C10.9 12.61 11.39 13.1 12 13.1C12.61 13.1 13.1 12.61 13.1 12C13.1 11.39 12.61 10.9 12 10.9ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM14.19 14.19L6 18L9.81 9.81L18 6L14.19 14.19Z',
      key: 'rhev87',
    },
  ],
]);

export default Explore;
